import { debounce, reduce } from 'lodash';
import { Component } from 'react';

import {
  BREAKPOINTS_DICT,
  BREAKPOINTS_SORTED_LIST,
  getCurrentBreakpoint,
  IBreakpoint,
} from '@opendoor/shared-fe/build/mediaBreakpoints';

const FPS_60_MS = Math.floor(1000 / 60);

// we could also pass in the current max breakpoint width.
// at call site we'd do (maxBreakpointWidth > BREAKPOINTS['M']).
// pros: less data passed through
// cons: need to import 'BREAKPOINTS' to use
interface IBreakpointState {
  gtXS: boolean;
  gtSM: boolean;
  gtMD: boolean;
  gtLG: boolean;
}

interface IState {
  breakpoint: IBreakpoint;
}

interface IProps {
  render: (breakpointState: IBreakpointState) => JSX.Element;
}

class Responsive extends Component<IProps, IState> {
  private debouncedResize = null; // for resize handler in mount/unmount

  constructor(props) {
    super(props);

    this.state = {
      breakpoint: getCurrentBreakpoint(),
    };
  }

  public componentDidMount() {
    this.debouncedResize = debounce(this.handleResize, FPS_60_MS);
    window.addEventListener('resize', this.debouncedResize);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
  }

  public render() {
    return this.props.render(this.getBreakpointState());
  }

  private handleResize = () => {
    this.setState({ breakpoint: getCurrentBreakpoint() });
  };

  private isViewportGreaterThan = (breakpoint: IBreakpoint) => {
    return BREAKPOINTS_DICT[this.state.breakpoint] >= BREAKPOINTS_DICT[breakpoint];
  };

  private getBreakpointState = (): IBreakpointState => {
    return reduce(
      BREAKPOINTS_SORTED_LIST,
      (breakpointState, breakpoint: IBreakpoint) => {
        breakpointState[`gt${breakpoint}`] = this.isViewportGreaterThan(breakpoint);
        return breakpointState;
      },
      {} as IBreakpointState,
    );
  };
}

export default Responsive;
